export const DefaultErrorFallback = () => {
  const isProduction = process.env.NODE_ENV === "production";

  return (
    <div data-testid="error-boundary-fallback" style={isProduction ? { display: "none" } : {}}>
      <span>An error occurred while rendering the component.</span>
    </div>
  );
};
